import { BUSINESS, LEGAL_DISCLOSURE } from "@/lib/business";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#12203f] text-white/80">
    <div className="container-tn py-14 lg:py-16">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src={BUSINESS.logoUrl}
              alt="Trusted Notary Illinois seal"
              className="h-14 w-14 rounded-full object-cover ring-1 ring-gold-soft/50"
            />
            <div>
              <p className="font-serif text-white uppercase tracking-[0.18em] text-lg font-bold leading-tight">
                Trusted Notary
              </p>
              <p className="font-serif text-gold uppercase tracking-[0.3em] text-xs">Illinois</p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed max-w-md text-white/70">
            Mobile notary public serving River Grove and the western &amp; northwest Chicago
            suburbs. Homes, offices, hospitals, and care facilities.
          </p>
        </div>

        <div>
          <p className="font-serif text-gold uppercase tracking-[0.2em] text-xs mb-4">Contact</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={`tel:${BUSINESS.phoneHref}`} className="flex items-start gap-2 hover:text-gold transition-colors">
                <Phone className="w-4 h-4 text-gold mt-0.5" /> {BUSINESS.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${BUSINESS.email}`} className="flex items-start gap-2 hover:text-gold transition-colors break-all">
                <Mail className="w-4 h-4 text-gold mt-0.5 shrink-0" /> {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-gold mt-0.5" />
              <span>{BUSINESS.city}<br />Serving the western &amp; northwest Chicago suburbs</span>
            </li>
          </ul>
        </div>

        <div>
          <p className="font-serif text-gold uppercase tracking-[0.2em] text-xs mb-4">Navigate</p>
          <ul className="space-y-2.5 text-sm">
            {["Services", "Service Area", "Pricing", "About", "FAQ", "Contact"].map((l) => (
              <li key={l}>
                <a
                  href={`#${l.toLowerCase().replace(/\s+/g, "-")}`}
                  className="hover:text-gold transition-colors"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 text-xs leading-relaxed text-white/60 space-y-3">
        <p data-testid="legal-disclosure">{LEGAL_DISCLOSURE}</p>
        <p className="flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Trusted Notary Illinois. All rights reserved.</span>
          <span>Website designed for mobile-first booking.</span>
        </p>
      </div>
    </div>
  </footer>
);
